import { Fixtuur } from '@fixtuur/backpack';
import * as Arr from 'fp-ts/Array';
import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/lib/function';
import * as POpt from './propertyOption/option';
export * as Option from './propertyOption/option';
var IP = Fixtuur.InspirationProduct;
var CProp = Fixtuur.Configuration.ConfigurableProperties;
export var fromFixtuurInspirationProduct = function (inspirationProduct, selectedVariantId) {
    var configurableProperties = Fixtuur.Configuration.ConfigurableProperties.fromProductVariants(Fixtuur.InspirationProduct.variants(inspirationProduct));
    return pipe(CProp.propertyNames(configurableProperties), Arr.map(function (name) {
        return pipe(CProp.property(name, configurableProperties), O.map(function (property) { return ({ name: name, property: property }); }));
    }), Arr.compact, Arr.map(function (_a) {
        var _b;
        var name = _a.name, property = _a.property;
        var sorter = new Intl.Collator('en-GB', { numeric: true }); // TODO: i18n
        return {
            name: name,
            displayName: property.displayName,
            alwaysDisplay: (_b = property.alwaysDisplay) !== null && _b !== void 0 ? _b : false,
            options: POpt.fromFixtuurPropertyValues(selectedVariantId, name, property.propertyValues, inspirationProduct).sort(function (a, b) { return sorter.compare(a.displayName, b.displayName); }),
        };
    }));
};
/**
 * Uses Options to create a Property for each Fixtuur Option Name, basing the Properties on the values associated with that Name.
 */
export var fromFixtuurOptions = function (configurableProperties, allOptions, 
/** set of currently selected options, used to determine which other options are selected */
selectedOptions, 
/** set of currently compatible options, used to determine which other options are disabled */
compatibleOptions) {
    return pipe(Fixtuur.Configuration.Options.names(allOptions), Arr.map(function (name) {
        return pipe(Fixtuur.Configuration.Options.valuesByName(name, allOptions), O.map(function (values) {
            return values.map(function (value) {
                return POpt.fromFixtuur(configurableProperties, name, value, Fixtuur.Configuration.Option.valueEquals(Fixtuur.Configuration.Selections.getByName(selectedOptions, name), value), !Fixtuur.Configuration.Options.isOptionIncluded(compatibleOptions, name, value));
            });
        }), O.chain(function (options) {
            // sorts both A->Z for text and in ascending numeric order for dimensions
            var sorter = new Intl.Collator('en-GB', { numeric: true }); // TODO: i18n
            options.sort(function (a, b) { return sorter.compare(a.displayName, b.displayName); });
            return pipe(Fixtuur.Configuration.ConfigurableProperties.property(name, configurableProperties), O.map(function (property) { return ({
                name: name,
                displayName: property.displayName,
                alwaysDisplay: Fixtuur.Configuration.ConfigurableProperties.isAlwaysDisplayProperty(name, configurableProperties),
                options: options,
            }); }));
        }));
    }), 
    // Throw away any Option names where we can't find any values.
    // Because we get our names from the same object as the options, this shouldn't happen, but we have to make the type system happy.
    Arr.compact);
};
